// "use client";

// import { AppProvider } from "@/context/AppContext";
// import { Toaster } from "@/components/ui/toaster";
// import "maplibre-gl/dist/maplibre-gl.css";

// export default function ClientProviders({
//   children,
// }: {
//   children: React.ReactNode;
// }) {
//   return (
//     <AppProvider>
//       {children}
//       <Toaster />
//     </AppProvider>
//   );
// }

"use client";

import { ReactNode, useState } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AppProvider } from "@/context/AppContext";
import { ToastProvider as CustomToastProvider } from "@/components/ui/use-toast";
import { Toaster } from "@/components/ui/toaster";

export default function ClientProviders({ children }: { children: ReactNode }) {
  const [queryClient] = useState(() => new QueryClient());

  return (
    <QueryClientProvider client={queryClient}>
      <AppProvider>
        <CustomToastProvider>
          {children}
          <Toaster />
        </CustomToastProvider>
      </AppProvider>
    </QueryClientProvider>
  );
}
